export const ACTION_TEMP_OUTPUT_SOCKET_ID = '__action_temp_output__';
export const ACTION_TEMP_INPUT_SOCKET_ID = '__action_temp_input__';
